// Vue-direktivet v-eui-maintain-tab-focus kan användas för att begränsa tabbning till inom det element direktivet appliceras på. Förhindrar även tabbning ut ur sidan, till webbläsarens UI.
//
// Bygger på ally.js: https://allyjs.io/api/maintain/tab-focus.html


//import Vue from 'vue';
import allyMaintainTabFocus from 'ally.js/src/maintain/tab-focus';


const directive = {

	name: 'eui-maintain-tab-focus',

	// called only once, when the directive is first bound to the element. This is where you can do one-time setup work.
	bind(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : BIND, value = ' + binding.value);

		// Initial status:
		vnode.$_allyMaintainTabFocus = null;
	},

	// called when the bound element has been inserted into its parent node (this only guarantees parent node presence, not necessarily in-document).
	inserted(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : INSERTED, value = ' + binding.value);

		binding.def.aktiveraEllerInaktiveraMaintainTabFocus(el, binding, vnode, null);
	},

	// called after the containing component’s VNode has updated, but possibly before its children have updated. The directive’s value may or may not have changed, but you can skip unnecessary updates by comparing the binding’s current and old values (see below on hook arguments).
	update(el, binding, vnode, oldVnode) {
		// Flytta över detta instansvärde:
		vnode.$_allyMaintainTabFocus = oldVnode.$_allyMaintainTabFocus;

		//console.log('id=' + vnode.context._self._uid + ' : UPDATE, value = ' + binding.oldValue + '–>' + binding.value);

		if (binding.value !== binding.oldValue)
		{
			binding.def.aktiveraEllerInaktiveraMaintainTabFocus(el, binding, vnode, oldVnode);
		}
	},

	//// called after the containing component’s VNode and the VNodes of its children have updated.
	//componentUpdated(el, binding, vnode, oldVnode) {
	//},

	// called only once, when the directive is unbound from the element.
	unbind(el, binding, vnode) {
		// Avbryt, om maintain tab-focus pågår:
		binding.def.inaktiveraMaintainTabFocusOmDenÄrAktiverad(el, vnode);
	},


	// Helper methods:   ==========================================================================================

	aktiveraEllerInaktiveraMaintainTabFocus(el, binding, vnode, oldVnode) {
		//console.log('–> id=' + vnode.context._self._uid + ' : MaintainTabFocus ' + binding.oldValue + '–>' + binding.value + ', $_allyMaintainTabFocus = ' + vnode.$_allyMaintainTabFocus);

		if (binding.value) {
			//// Avbryt först, om maintain tab-focus pågår (vet inte om detta behövs egentligen, men kanske ökat behov i och med Vue:s trix med DOM?):
			//binding.def.inaktiveraMaintainTabFocusOmDenÄrAktiverad(el, vnode);

			// Begränsa tabbning till inom elementet:
			vnode.$_allyMaintainTabFocus = allyMaintainTabFocus({
				context: el,
			});

			vnode.context.$emit('eui-maintain-tab-focus-aktiverad', { element: el, value: binding.value });
		}
		else {
			// Annars: Avbryt, om maintain tab-focus pågår:
			binding.def.inaktiveraMaintainTabFocusOmDenÄrAktiverad(el, vnode);
		}

		//console.log('<– id=' + vnode.context._self._uid + ' : MaintainTabFocus ' + binding.oldValue + '–>' + binding.value + ', $_allyMaintainTabFocus = ' + vnode.$_allyMaintainTabFocus);
	},


	inaktiveraMaintainTabFocusOmDenÄrAktiverad(el, vnode) {
		// Avbryt, om disable pågår:

		//vnode.$_allyMaintainTabFocus && vnode.$_allyMaintainTabFocus.disengage();

		if (vnode.$_allyMaintainTabFocus)
		{
			vnode.$_allyMaintainTabFocus.disengage();
			vnode.context.$emit('eui-maintain-tab-focus-inaktiverad', { element: el });
			vnode.$_allyMaintainTabFocus = null;	// För tydlighet!
		}
	}
};


//const registerDirectiveGlobally = function () {
//	Vue.directive(directive.name, directive);
//};


//const euiMaintainTabFocus = {
//	// Properties:
//	directive,

//	// Methods:
//	registerDirectiveGlobally
//};

export default directive;
